import { Typography } from 'shared/ui'
import { getAriaLabel } from 'shared/lib'
import { OverallLineChart } from 'pages/analytics/pages/overall/ui/OverallLineChart/OverallLineChart'
import styles from './styles.module.scss'

interface OverallAnalyticsCardProps {
  title: string
  value?: number
  data?: number[]
  formatValue?: (value: number) => string
}

export const OverallAnalyticsCard = ({
  title,
  value = 0,
  data = [],
  formatValue,
}: OverallAnalyticsCardProps) => {
  const titleAriaLabel = getAriaLabel(title, 'Title')
  const valueAriaLabel = getAriaLabel(title, 'Value')

  const formattedValue = formatValue ? formatValue(value) : value.toLocaleString()

  return (
    <div className={styles.metricCard}>
      <Typography variant='body-rg-regular' color='tertiary' ariaLabel={titleAriaLabel}>
        {title}
      </Typography>
      <Typography variant='heading-lg' ariaLabel={valueAriaLabel} marginBottom='12px'>
        {formattedValue}
      </Typography>
      <OverallLineChart data={data} />
    </div>
  )
}
